import request from '@/utils/request';

export function getSuperviseurDashboard(params) {
  return request({
    url: '/superviseur/dashboard',
    method: 'get',
    params,
  });
}

export function getSuperviseurActivites(params) {
  return request({
    url: '/superviseur/activites',
    method: 'get',
    params,
  });
}

export function getSuperviseurControleurs(params) {
  return request({
    url: '/superviseur/controleurs',
    method: 'get',
    params,
  });
}

export function getSuperviseurRapport(params) {
  return request({
    url: '/superviseur/rapport-activite',
    method: 'get',
    params,
  });
}

export function exportSuperviseurRapport(params) {
  return request({
    url: '/superviseur/rapport-activite',
    method: 'get',
    params: { ...params, format: 'xlsx' },
    responseType: 'blob',
  });
}

export function approuverFormationSuperviseur(id, data) {
  return request({
    url: `/superviseur/formations/${id}/approbation`,
    method: 'post',
    data,
  });
}

export function approuverAuditSuperviseur(id, data) {
  return request({
    url: `/superviseur/audits/${id}/approbation`,
    method: 'post',
    data,
  });
}

export function approuverParcelleModificationSuperviseur(id, data) {
  return request({
    url: `/superviseur/parcelle-modifications/${id}/approbation`,
    method: 'post',
    data,
  });
}

export function saveControleurSignature(id, formData) {
  return request({
    url: `/controleurs/${id}/signature`,
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
